
import React from "react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

interface ChatMessageProps {
  sender: "user" | "ai";
  text: string;
  timestamp: string;
}

export const ChatMessage = ({ sender, text, timestamp }: ChatMessageProps) => {
  const isUserMessage = sender === "user";

  return (
    <div className={`flex items-start gap-2.5 ${isUserMessage ? "justify-end" : "justify-start"} mb-4`}>
      {!isUserMessage && (
        <Avatar className="h-8 w-8 flex-shrink-0">
          <AvatarImage src="https://github.com/shadcn.png" alt="AI Avatar" />
          <AvatarFallback>AI</AvatarFallback>
        </Avatar>
      )}
      
      <div className="flex flex-col max-w-[70%]">
        <div 
          className={`rounded-lg px-3 py-2 ${
            isUserMessage 
              ? "bg-[#D9FDD3] text-black rounded-tr-none ml-auto" 
              : "bg-white text-black rounded-tl-none"
          }`}
        >
          <p className="text-sm whitespace-pre-wrap break-words">{text}</p>
        </div>
        <span 
          className={`text-xs text-gray-500 mt-1 ${isUserMessage ? "text-right" : "text-left"}`}
        >
          {timestamp}
        </span>
      </div>
      
      {isUserMessage && (
        <Avatar className="h-8 w-8 flex-shrink-0">
          <AvatarImage src="https://github.com/shadcn.png" alt="User Avatar" />
          <AvatarFallback>ME</AvatarFallback>
        </Avatar>
      )}
    </div>
  );
};
